import type { IconData } from '@stacksjs/iconify-core'

export const arrowTurnDownLarge: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M27.519 32.739c1.411-1.987.336-4.284-2.096-4.452a113 113 0 0 0-4.489-.209a556 556 0 0 1-.107-5.898c-.056-4.299 2.757-8 7.057-8c4.531 0 7.587 3.942 7.587 8.473V34.01c0 1.665.881 3.2 2.526 3.458c.633.1 1.393.167 2.29.167c.899 0 1.66-.067 2.292-.167c1.645-.258 2.526-1.793 2.526-3.459V21.264c0-9.894-7.327-18.26-17.221-18.26c-10.676 0-18.68 9.058-18.818 19.732a807 807 0 0 1-.085 5.346c-1.78.052-3.23.125-4.402.206c-2.432.168-3.507 2.465-2.096 4.453c1.024 1.44 2.43 3.306 4.336 5.637c2.913 3.562 5.048 5.494 6.405 6.52c1.083.82 2.47.82 3.553 0c1.357-1.026 3.492-2.958 6.405-6.52c1.907-2.332 3.313-4.197 4.337-5.638Z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowTurnDownLarge
